import React, { useEffect, useState } from 'react';
import { BsXLg } from 'react-icons/bs';
import { useMutation } from 'react-query';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { globalEnv } from '../../../../config/baseConfig';
import { useTypedSelector } from '../../../../hooks/useTypeSelector';
import { SetNotificationAction } from '../../../../redux/actions/notificationAction';
import { stateNotificationsEnum } from '../../../Utils/notification';
import placeholder from '../../../../assets/images/placeholder.png';
import { axiosInstance } from '../../../../config/axiosInstance';
import RemoveModal from '../../../Utils/Components/removeModal';
import LazyImage from '../../../Utils/Components/imageComponent';
import { AiFillStar, AiOutlineStar } from 'react-icons/ai';

export type singleVideoProps = {
	topicId: string;
	item: any;
	isMine: boolean;
	videos: any[];
	setVideos: (videos: any[]) => void;
	extensionVideos?: any[];
	setExtensionVideos?: (extensionVideos: any[]) => void;
	setIsChanged: (isChanged: boolean) => void;

	reloadCount: number;
	setReloadCount: (count: number) => void;

	setEditVideoModalOpen?: (isOpen: boolean) => void;
	setEditVideoModalId?: (videoId: string) => void;
	isForPhone: boolean;
};

export interface IDeleteMedia {
	topicId: string;
	mediaId: string;
}

export const VideoComponent = ({
	item,
	topicId,
	isMine,
	videos,
	setVideos,
	reloadCount,
	setReloadCount,

	setEditVideoModalId,
	setEditVideoModalOpen,
	isForPhone,
	setIsChanged,

	extensionVideos,
	setExtensionVideos
}: singleVideoProps) => {
	const [isRemoveModalOpen, setIsRemoveModalOpen] = useState(false);
	const [isSelectedForExtension, setIsSelectedForExtension] = useState(false);

	const { ACCESS_TOKEN } = useTypedSelector((state) => state.auth);

	const dispatch = useDispatch();

	// const { width } = useTypedSelector((state) => state.global);

	const removeVideoReq = async (data: IDeleteMedia) => {
		const params = new URLSearchParams();
		params.append('mediaId', data.mediaId);
		params.append('topicId', data.topicId);

		const config = {
			headers: {
				Authorization: 'Bearer ' + ACCESS_TOKEN
			}
		};

		const { data: response } = await axiosInstance.put(
			globalEnv.BASE_URL + '/admin/topic/delete-video',
			params,
			config
		);
		return response;
	};

	const { mutate } = useMutation(removeVideoReq, {
		onSuccess: () => {
			setVideos(videos.filter((video) => video._id != item._id));
			setReloadCount(reloadCount + 1);

			dispatch(
				SetNotificationAction({
					type: stateNotificationsEnum.SUCCESS,
					message: 'Successfully deleted Video from topic.'
				})
			);
		},
		onError: () => {
			dispatch(
				SetNotificationAction({
					type: stateNotificationsEnum.ERROR,
					message: "couldn't delete Video from topic."
				})
			);
		}
	});

	const removeVideo = (topicId: string, mediaId: string) => {
		mutate({ topicId, mediaId });
	};

	const navigate = useNavigate();
	const accessVideo = () => {
		if (setEditVideoModalOpen && setEditVideoModalId) {
			setEditVideoModalOpen(true);
			setEditVideoModalId(item._id);
		} else {
			if (isForPhone) navigate(`phone-video/${item._id}`);
			else navigate(`video/${item._id}`);
		}
	};

	const addVideoToExtension = (id: string) => {
		if (setExtensionVideos != null && extensionVideos != null) {
			const extensionVideosCopy = extensionVideos.slice();
			extensionVideosCopy.push(id);
			setExtensionVideos(extensionVideosCopy);
			setIsChanged(true);
		}
	};
	const removeVideoFromExtension = (id: string) => {
		if (setExtensionVideos != null && extensionVideos != null) {
			const extensionVideosCopy = extensionVideos.slice();
			const index = extensionVideosCopy.findIndex((video) => video == id);
			extensionVideosCopy.splice(index, 1);
			setExtensionVideos(extensionVideosCopy);
			setIsChanged(true);
		}
	};

	useEffect(() => {
		if (extensionVideos?.includes(item._id)) setIsSelectedForExtension(true);
		else setIsSelectedForExtension(false);
	}, [extensionVideos]);

	return (
		<div
			className={`flex flex-wrap flex-col p-4 cursor-pointer ${
				isForPhone ? ' w-1/6' : ' w-1/3'
			}`}
			onClick={() => {
				if (isMine) accessVideo();
			}}
		>
			<div>
				<RemoveModal
					title={'Remove Video'}
					text={'Are you sure you want to remove this video?'}
					setModalOpen={setIsRemoveModalOpen}
					setAction={() => removeVideo(topicId, item._id)}
					visible={isRemoveModalOpen}
				/>
			</div>
			<div
				className={`relative rounded-lg flex justify-center content-center w-full overflow-hidden
						dark:bg-gray-600 bg-gray-300 mb-2 group ${isForPhone ? 'aspect-[10/18]' : ''}`}
			>
				<video>
					<source src={item.url} type="video/mp4" />
				</video>

				<>
					<button className="absolute top-2 right-2 btn-primary btn-xs btn btn-circle btn-outline shadow-md">
						{isSelectedForExtension ? <AiFillStar /> : <AiOutlineStar />}
					</button>
				</>

				<div
					className="absolute inset-0 bg-gradient-to-t rounded-lg
							from-black/75 opacity-0 group-hover:opacity-100 transition-all duration-500 text-center"
				>
					{isMine && (
						<>
							<div className="group-1">
								<button
									className="absolute top-2 left-2 btn-error btn-xs btn btn-circle btn-outline shadow-md"
									onClick={(e) => {
										if (videos.length > 0) {
											e.stopPropagation();
											setIsRemoveModalOpen(true);
										}
									}}
								>
									<BsXLg />
								</button>
								<span
									className="absolute rounded-md shadow-md text-white bg-gray-900 p-2 min-w-max text-xs
											scale-0 origin-left group-1-hover:scale-100
						              		font-bold transition-all duration-500 opacity-0 group-1-hover:opacity-100 top-1 left-10 z-50"
								>
									{videos.length <= 0 ? "Can't remove 🚫" : 'Remove ❌'}
								</span>
							</div>

							{item.url_low_res != null && (
								<div>
									<div className="group-1">
										<button
											className="absolute top-2 right-2 btn-primary btn-xs btn btn-circle btn-outline shadow-md"
											onClick={(e) => {
												e.stopPropagation();
												isSelectedForExtension
													? removeVideoFromExtension(item._id)
													: addVideoToExtension(item._id);
											}}
										>
											{isSelectedForExtension ? (
												<AiFillStar />
											) : (
												<AiOutlineStar />
											)}
										</button>
										<span
											className="absolute rounded-md shadow-md text-white bg-gray-900 p-2 min-w-max text-xs
											scale-0 origin-left group-1-hover:scale-100
						              		font-bold transition-all duration-500 opacity-0 group-1-hover:opacity-100 top-1 -right-36 mr-2 z-50"
										>
											{'Set extension video'}
										</span>
									</div>
								</div>
							)}
						</>
					)}
				</div>
			</div>
			<h3 className="mx-auto text-gray-700 dark:text-gray-200 font-semibold">
				{item.title}
			</h3>
		</div>
	);
};
